<template>
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M78,36H72V24a24,24,0,0,0-48,0V36H18a5.9966,5.9966,0,0,0-6,6V90a5.9966,5.9966,0,0,0,6,6H78a5.9966,5.9966,0,0,0,6-6V42A5.9966,5.9966,0,0,0,78,36ZM36,24a12,12,0,0,1,24,0V36H36ZM72,84H24V48H72Z"/>
  </svg>
</template>
